export default "__VITE_ASSET__BgLEPW6m__"